import { ListFilters } from "../ListFilters";

export type AssetKindFilterTab = {
  count: number;
  label: string;
  value: string;
};

type AssetKindFilterProps = {
  onChange: (value: string) => void;
  tabs: AssetKindFilterTab[];
  value: string;
};

export function AssetKindFilter({
  onChange,
  tabs,
  value,
}: AssetKindFilterProps) {
  return (
    <ListFilters
      activeFilterCount={value === "all" ? 0 : 1}
      ariaLabel="Asset filters"
      facets={[
        {
          key: "kind",
          label: "Kind",
          options: tabs
            .filter((tab) => tab.value !== "all")
            .map((tab) => ({
              label: `${tab.label} (${tab.count})`,
              value: tab.value,
            })),
          value: value === "all" ? [] : [value],
          selectionMode: "single",
          onChange: (selected) => onChange(selected[0] ?? "all"),
        },
      ]}
      onReset={() => onChange("all")}
    />
  );
}
